<template>
	<div id="app">
		<Header></Header>
		<main>
			<router-view  :key="$route.fullPath"/>
		</main>
		<Footer></Footer>
		<scroll-top />
	</div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import ScrollTop from '@/components/ScrollTop'
export default {
	name: 'App',
	components: {
		Header,
		Footer,
		ScrollTop,
	},
	computed: {},
	provide() {
		return {
			navList: this.getNav(this.$router.options.routes),
		}
	},
	created() {
		//console.log(this.$router.options.routes)
	},
	methods: {
		getNav(routes, parentPath = '') {
			return routes.map((route) => {
				return {
					title: route.meta?.title,
					title_en: route.meta?.title_en,
					path: parentPath
						? `${parentPath}/${route.path}`
						: route.path,
					name: route.name,
					children:
						route.children &&
						this.getNav(
							route.children.filter(
								(childRoute) => childRoute.meta.isNav
							),
							route.path
						),
				}
			})
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/scss/base.scss';
@import '@/assets/scss/common.scss';
#app {
	background-color: $page-bg;
}
</style>
